(ns frontend.components.inputs.percentage
  (:require
   [frontend.components.inputs.footprint :refer [display-string editor viewer]]
   [frontend.utils :as fu]
   [frontend.utils :as utils]
   [reagent.core :as r]))

(defn render
  [dom-atom args]
  (let [{:keys [:value :class-name :placeholder
                :has-focus?
                :on-focus! :on-blur! :on-change!
                :on-key-down! :disabled? :base-multiplier]}
        args
        raw-value (:temp-value @dom-atom)
        edit-decimals (if (nil? raw-value) -1 (get @dom-atom :decimal-count))
        edit-value (or raw-value (* 100 value))
        edit-negative? (get @dom-atom :negative?)
        ;; We break pure function here - makes using the number formatter bit easier -- TODO: should we not do this ?
        clear-state! (fn []
                       (swap! dom-atom dissoc
                         :temp-value
                         :negative?
                         :cleared?))]
    [:input
     (merge {:ref         (fn [e]
                            (when (and e
                                       (not= e (:input-dom-node @dom-atom)))
                              (swap! dom-atom assoc :input-dom-node e)))
             :placeholder (str placeholder)
             :type        "text"
             :class-name  (fu/cs "component-percentage" (when has-focus? "focus") class-name)
             :on-focus    (fn [e]
                            (js/setTimeout #(.select (:input-dom-node @dom-atom)) 10) ;; all desktop browsers - select all text
                            (when on-focus!
                              (on-focus! e)))
             :on-blur     (fn [e]
                            (when on-blur!
                              (on-blur! e (/ edit-value 100) clear-state!)))
             :value       (let [v (if-not has-focus?
                                    (if (nil? value)
                                      ""
                                      (str (utils/format-with-separators (* 100 value) 2 false 3) "%"))
                                    (let [draw-value edit-value
                                          min-decimal-count edit-decimals]
                                      (or
                                       (when draw-value
                                         (if (= draw-value "")
                                           (when edit-negative? "-")
                                           (utils/format-with-separators draw-value min-decimal-count edit-negative? 5))) ;; append decimal when editing without decimals
                                       "")))]
                            v)
             :on-key-down (fn [e]
                            (when on-key-down!
                              (on-key-down! e)))
             :on-change   (fn [e]
                            (let [input (-> e
                                            .-target
                                            .-value)
                                  float-value (utils/parse-float-info input "")]
                              (swap! dom-atom assoc
                                :decimal-count (or (:decimal-count float-value) -1)
                                :negative? (or (:negative? float-value) false)
                                :temp-value (:float-value float-value))
                              (deref dom-atom)
                              (when on-change!
                                (on-change! e
                                            (when-let [fv (:float-value float-value)]
                                              (/ fv 100))))))}
            (when disabled?
              {:disabled (boolean disabled?)}))]))


(defmethod editor :editor.type/percentage
  [args]
  (let [dom-atom (or (:state-atom args) (r/atom nil))
        set-focusable! (:set-focusable-element! args)
        set-cancel-edit! (:set-cancel-edit! args)
        set-save! (:set-save! args)]                        ;; when do we reset the state ?
    ;; ref vs atom
    (r/create-class
     {:display-name           "Percentage"
      :component-did-mount    (fn [args]
                                (let []
                                  (when set-focusable!
                                    (set-focusable! (fn [_]
                                                      (when-let [dom-node (:input-dom-node @dom-atom)]
                                                        (.focus dom-node)))))
                                  (when set-cancel-edit!
                                    (set-cancel-edit! (fn [_]
                                                        (swap! dom-atom dissoc :temp-value)))) ;; save complete -> reset temp state
                                  (when set-save!
                                    (set-save! (fn [_]
                                                 (when-let [dom-node (:input-dom-node @dom-atom)]
                                                   (.blur dom-node)))))))
      :component-will-unmount (fn []
                                (swap! dom-atom dissoc :input-dom-node))
      :reagent-render         (fn [args]
                                (render dom-atom args))})))

(defmethod display-string :editor.type/percentage
  [args]
  (let [value (:value args)]
    (cond (fu/is-bigdec? value)
          (str (fu/format-with-separators (fu/bigdec->float (* 100 value)) 1 false 3) "%")
          (float? value)
          (str (fu/format-with-separators (* 100 value) 1 false 3) "%")
          :else
          (str value))))

(defmethod viewer :editor.type/percentage
  [args]
  (r/create-class
   {:display-name   "percentage/viewer"
    :reagent-render (fn [args]
                      (let [value (:value args)]
                        [:div.preview.preview-percentage
                         (display-string args)]))}))
